module.exports = __webpack_public_path__ + "static/img/grade_17.3a01e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_17.png
// module id = 1wgQ
// module chunks = 89